import React from 'react';
import Text from 'design-system/Text';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
import { useConnectedAccount } from 'features/invest/hooks/selectors';
const EmmaBalanceInfoCard = ({ dateTimeString, isBankTransfer }) => {
    const connectedAccount = useConnectedAccount();
    return (<ProgressCard lightBg lastItem noTextDecoration completed={false} timeInfo={dateTimeString} title={isBankTransfer
            ? `Available in your ${connectedAccount?.bankName || 'Linked account'}`
            : 'Available in Emma wallet'}>
      {!isBankTransfer && (<Text TextThin-14 Secondary>
          Once your funds arrive, you can decide to invest, deposit again, or withdraw to your bank account.
        </Text>)}
    </ProgressCard>);
};
export default EmmaBalanceInfoCard;
